export enum Position {
	SUPERADMIN = "ideas_superadmin",
	ADMIN = "ideas_administrador",
	COLAB = "ideas_colaborador",
}

export const POSITIONS_AVAILABLE: string[] = ["ideas_superadmin", "ideas_administrador", "ideas_colaborador"];

export const HOSPITALS_AVAILABLE: string[] = [
	"ideas_alta_especialidad",
	"ideas_altagracia",
    "ideas_betania",
    "ideas_conchita",
    "ideas_cumbres",
    "ideas_del_parque",
    "ideas_irapuato",
    "ideas_juventud",
    "ideas_merida",
    "ideas_reynosa",
    "ideas_saltillo",
    "ideas_san_nicolas",
    "ideas_san_pedro",
    "ideas_sur",
    "ideas_upaep",
    "ideas_vidriera",
    "ideas_faro_mayab",
    "ideas_cam_chapultepec",
    "ideas_cam_elite",
    "ideas_cam_escobedo",
    "ideas_cam_huinala",
    "ideas_cam_leones",
    "ideas_cam_santa_catarina",
    "ideas_cam_sendero",
    "ideas_cam_vergel",
    "ideas_724",
    "ideas_corporativo",
    "ideas_fundacion_adelaida_lafon"
];

export const HOSPITALS_MAP: { [key: string]: string } = {
	ideas_alta_especialidad: "Alta Especialidad",
    ideas_altagracia: "Altagracia",
    ideas_betania: "Betania",
    ideas_conchita: "Conchita",
    ideas_cumbres: "Cumbres",
    ideas_del_parque: "Del Parque",
    ideas_irapuato: "Irapuato",
    ideas_juventud: "Juventud",
    ideas_merida: "Merida",
    ideas_reynosa: "Reynosa",
    ideas_saltillo: "Saltillo",
    ideas_san_nicolas: "San Nicolás",
    ideas_san_pedro: "San Pedro",
    ideas_sur: "Sur",
    ideas_upaep: "UPAEP",
    ideas_vidriera: "Vidriera",
    ideas_faro_mayab: "Faro del Mayab",
    ideas_cam_chapultepec: "CAM Chapultepec",
    ideas_cam_elite: "CAM Elite",
    ideas_cam_escobedo: "CAM Escobedo",
    ideas_cam_huinala: "CAM Huinalá",
    ideas_cam_leones: "CAM Leones",
    ideas_cam_santa_catarina: "CAM Santa Catarina",
    ideas_cam_sendero: "CAM Sendero",
    ideas_cam_vergel: "CAM Vergel",
    ideas_724: "7-24",
    ideas_corporativo: "Corporativo",
    ideas_fundacion_adelaida_lafon: "Fundación Adelaida Lafón"
};